import { render, staticRenderFns } from "./ProductUnitsList.vue?vue&type=template&id=530fbfe6&scoped=true&"
import script from "./ProductUnitsList.vue?vue&type=script&lang=js&"
export * from "./ProductUnitsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530fbfe6",
  null
  
)

export default component.exports